import { render, staticRenderFns } from "./hotDiyCanvas.vue?vue&type=template&id=cfde5b94&scoped=true&"
import script from "./hotDiyCanvas.vue?vue&type=script&lang=js&"
export * from "./hotDiyCanvas.vue?vue&type=script&lang=js&"
import style0 from "./hotDiyCanvas.vue?vue&type=style&index=0&id=cfde5b94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde5b94",
  null
  
)

export default component.exports